import { format, startOfDay, differenceInCalendarDays } from 'date-fns';

/**
 * 相対日付表示ユーティリティ
 * - 本日: "本日 HH:mm"
 * - 1〜6日前: "○日前"
 * - 7日以上前: "yyyy/MM/dd"
 */
export function formatRelativeDate(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  if (isNaN(date.getTime())) return '';

  const now = new Date();
  const today = startOfDay(now);
  const targetDay = startOfDay(date);
  const diffDays = differenceInCalendarDays(today, targetDay);
  const time = format(date, 'HH:mm');

  if (diffDays === 0) return `本日 ${time}`;
  if (diffDays >= 1 && diffDays <= 6) return `${diffDays}日前`;

  return format(date, 'yyyy/MM/dd');
}
